/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  VerifyURLForm,
  VerifyURLForm$Outbound,
  VerifyURLForm$outboundSchema,
} from "../components/verifyurlform.js";

export type VerifyRemoteMcpURLSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type VerifyRemoteMcpURLSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type VerifyRemoteMcpURLSecurity = {
  option1?: VerifyRemoteMcpURLSecurityOption1 | undefined;
  option2?: VerifyRemoteMcpURLSecurityOption2 | undefined;
};

export type VerifyRemoteMcpURLRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  verifyURLForm: VerifyURLForm;
};

/** @internal */
export type VerifyRemoteMcpURLSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const VerifyRemoteMcpURLSecurityOption1$outboundSchema: z.ZodMiniType<
  VerifyRemoteMcpURLSecurityOption1$Outbound,
  VerifyRemoteMcpURLSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function verifyRemoteMcpURLSecurityOption1ToJSON(
  verifyRemoteMcpURLSecurityOption1: VerifyRemoteMcpURLSecurityOption1,
): string {
  return JSON.stringify(
    VerifyRemoteMcpURLSecurityOption1$outboundSchema.parse(
      verifyRemoteMcpURLSecurityOption1,
    ),
  );
}

/** @internal */
export type VerifyRemoteMcpURLSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const VerifyRemoteMcpURLSecurityOption2$outboundSchema: z.ZodMiniType<
  VerifyRemoteMcpURLSecurityOption2$Outbound,
  VerifyRemoteMcpURLSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function verifyRemoteMcpURLSecurityOption2ToJSON(
  verifyRemoteMcpURLSecurityOption2: VerifyRemoteMcpURLSecurityOption2,
): string {
  return JSON.stringify(
    VerifyRemoteMcpURLSecurityOption2$outboundSchema.parse(
      verifyRemoteMcpURLSecurityOption2,
    ),
  );
}

/** @internal */
export type VerifyRemoteMcpURLSecurity$Outbound = {
  Option1?: VerifyRemoteMcpURLSecurityOption1$Outbound | undefined;
  Option2?: VerifyRemoteMcpURLSecurityOption2$Outbound | undefined;
};

/** @internal */
export const VerifyRemoteMcpURLSecurity$outboundSchema: z.ZodMiniType<
  VerifyRemoteMcpURLSecurity$Outbound,
  VerifyRemoteMcpURLSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => VerifyRemoteMcpURLSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => VerifyRemoteMcpURLSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function verifyRemoteMcpURLSecurityToJSON(
  verifyRemoteMcpURLSecurity: VerifyRemoteMcpURLSecurity,
): string {
  return JSON.stringify(
    VerifyRemoteMcpURLSecurity$outboundSchema.parse(verifyRemoteMcpURLSecurity),
  );
}

/** @internal */
export type VerifyRemoteMcpURLRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  VerifyURLForm: VerifyURLForm$Outbound;
};

/** @internal */
export const VerifyRemoteMcpURLRequest$outboundSchema: z.ZodMiniType<
  VerifyRemoteMcpURLRequest$Outbound,
  VerifyRemoteMcpURLRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    verifyURLForm: VerifyURLForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      verifyURLForm: "VerifyURLForm",
    });
  }),
);

export function verifyRemoteMcpURLRequestToJSON(
  verifyRemoteMcpURLRequest: VerifyRemoteMcpURLRequest,
): string {
  return JSON.stringify(
    VerifyRemoteMcpURLRequest$outboundSchema.parse(verifyRemoteMcpURLRequest),
  );
}
